/* Publish by EComposer at 2025-08-04 19:21:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-saxrs2j75ob"]=  window.__ectimmers["ecom-saxrs2j75ob"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-saxrs2j75ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-saxrs2j75ob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smkg75jy96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smkg75jy96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tt0a5criwqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tt0a5criwqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dil7vsf7ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dil7vsf7ws', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejt214wc7d6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejt214wc7d6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ougt142m5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ougt142m5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91xa4kpamib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91xa4kpamib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-024ln4t0qngb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-024ln4t0qngb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yp7oudes1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yp7oudes1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9dwlagbkev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9dwlagbkev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0dq68alsmlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0dq68alsmlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ga1mwkqglf5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ga1mwkqglf5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-calhm7i4rb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-calhm7i4rb8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6imrh14i5ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6imrh14i5ao', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8h6ju21sbp2"]=  window.__ectimmers["ecom-8h6ju21sbp2"] || {};
const e=this.$el;if(!e||!this.isLive)return;const i=e.querySelector(".element__featured--wrapper-list");if(i){let t={top:0,left:0,x:0,y:0};const n=function(a){const r=a.clientX-t.x;i.scrollLeft=t.left-r},s=function(){i.removeEventListener("mousemove",n),i.removeEventListener("mouseup",s),i.style.cursor="default",i.style.removeProperty("user-select")},o=function(a){i.style.cursor="grabbing",i.style.userSelect="none",t={left:i.scrollLeft,top:i.scrollTop,x:a.clientX,y:a.clientY},i.addEventListener("mousemove",n),i.addEventListener("mouseup",s)};i.addEventListener("mousedown",o),i.addEventListener("mouseleave",s)}

                    });
                    
                        document.querySelectorAll('.ecom-8h6ju21sbp2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8h6ju21sbp2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46ibpj4dvl2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46ibpj4dvl2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6eal1c3b50j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6eal1c3b50j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0tlozegcsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0tlozegcsl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gm67w4bru9r"]=  window.__ectimmers["ecom-gm67w4bru9r"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-gm67w4bru9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gm67w4bru9r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flmjc7xytw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flmjc7xytw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3pj39m14e9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3pj39m14e9i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13pvbrgfklt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13pvbrgfklt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wq2h0cl0nu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wq2h0cl0nu', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dkksgkfo8wa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dkksgkfo8wa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}